import React, { useMemo } from 'react';
import GraphQLRequestContext from './GraphQLRequestContext';
import { GraphQLClient } from 'graphql-request';

type Props = {
  children: React.ReactNode;
};

const GraphQLRequestProvider: React.FC<Props> = (props: Props) => {
  const { children } = props;

  const providerObject = useMemo(
    () => ({
      client: new GraphQLClient(`${process.env.REACT_APP_API_URL}graphql/`),
    }),
    [],
  );

  return (
    <GraphQLRequestContext.Provider value={providerObject}>
      {children}
    </GraphQLRequestContext.Provider>
  );
};

export default GraphQLRequestProvider;
